<script>
    import { api_get, api_post } from "../util/api_request";
    import StatusMessage from "../include/StatusMessage.svelte";
    import InviteCard from "../include/InviteCard.svelte";

    let response_msg;

    let user_invites;

    let create_invite = async () => {
        response_msg = await api_post("/api/user/create_invite");
        if (response_msg.status == 200)
            fetch_invites();
    }

    let fetch_invites = async () => {
        user_invites = await api_get("/api/user/get_invites");
    }

    // Whenever we receive some response message, update invites list
    $: response_msg, fetch_invites();
</script>

<div class="content">
    <div class="container">
        <h1>Inviting someone</h1>
        <p>Things you should know:</p>
        <ul>
            <li>You can only have one active invite at once.</li>
            <li>Invites expire after 24 hours.</li>
            <li>If you invite someone, you are responsible if he/she breaks any rules.</li>
            <li>Only invite people you can trust.</li>
        </ul>
        <hr>
        <StatusMessage message={response_msg} />
        <button class="btn" on:click={create_invite}>Create new invite code</button>
        <hr>
        <h2>Your created invites</h2>
        <div class="grid">
            {#if user_invites}
            {#each user_invites.data as invite_info}
            <InviteCard invite={invite_info} bind:response={response_msg}/>
            {/each}
            {/if}
        </div>
    </div>
</div>